import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type TokenAffiliateRecommenderState = {
  tokenAffilRecommender: string | undefined
  setToken: (token: string) => void
  removeToken: () => void
}

const useAffiliateStore = create<TokenAffiliateRecommenderState>()(
  persist(
    (set) => ({
      tokenAffilRecommender: undefined,
      setToken: (token: string) => {
        return set({ tokenAffilRecommender: token })
      },
      removeToken: () => {
        set({ tokenAffilRecommender: undefined })
        localStorage.removeItem('affil')
      },
    }),
    {
      name: 'affil',
    }
  )
)

function useAffilToken() {
  const { tokenAffilRecommender: tokenFromParams } = useParams<{
    tokenAffilRecommender: string
  }>()
  const { tokenAffilRecommender, setToken, removeToken } = useAffiliateStore()

  useEffect(() => {
    if (tokenFromParams) setToken(tokenFromParams)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenFromParams])

  return { tokenAffilRecommender, removeToken }
}

export { useAffilToken }
